/**
 * Verdicts, not weather: the broker/engine looked the account up and said no. Retrying these — by the
 * server loop, the automatic re-dial schedule, or the wake watchdog — can never succeed, so they stop
 * the attempt and show the modal. Matched case-insensitively: `user not found` is the ViiSync engine's
 * own lower-case wording, returned verbatim through the Vybe gateway.
 */
const CRITICAL_ERROR_MARKERS = [
  "INVALID_ACCOUNT",
  "ACCOUNT_DISABLED",
  "BAD_CREDENTIALS",
  "NOT_IMPLEMENTED",
  "user not found",
  "account not found",
] as const;

export function isCriticalConnectionError(message: string): boolean {
  const lowered = message.toLowerCase();
  return CRITICAL_ERROR_MARKERS.some((marker) =>
    lowered.includes(marker.toLowerCase())
  );
}

/**
 * The gateway rejected the credential itself, as opposed to failing to reach anything. Worth
 * distinguishing because a Vybe account's password can be rotated server-side by any CRM mint — on
 * another device, or by a portal reset — which strands a saved password that was correct yesterday.
 * `invalid credentials` is the ViiSync engine's own wording, returned verbatim through the hub.
 */
const AUTH_FAILURE_MARKERS = ["invalid credentials", "BAD_CREDENTIALS"] as const;

export function isAuthFailure(message: string): boolean {
  const lowered = message.toLowerCase();
  return AUTH_FAILURE_MARKERS.some((marker) =>
    lowered.includes(marker.toLowerCase())
  );
}

export function formatConnectionErrorMessage(message: string): string {
  if (message.includes("NOT_IMPLEMENTED")) {
    return "Trading gateway is not implemented yet.";
  }

  return message;
}

export function showConnectionError(
  message: string,
  setErrorMessageToShow: (value: string | null) => void,
  setShowErrorModal: (value: boolean) => void,
  setHasTriedAllServers: (value: boolean) => void
): void {
  setErrorMessageToShow(formatConnectionErrorMessage(message));
  setHasTriedAllServers(true);
  setShowErrorModal(true);
}
